import level1 from './level1.json'
import level2 from './level2.json'
import level3 from './level3.json'
import level4 from './level4.json'

let levels = {
    'level1': level1,
    'level2': level2,
    'level3': level3,
    'level4': level4
}

let hints = {
    'level1': 'Save the cabin.',
    'level2': 'Beware the logs.',
    'level3': 'Refill your tank.',
    'level4': 'Save both cabins.'
}

/**
 * Return the level name (null if it doesn't exist)
 * @param {string} level 
 * @returns {object}
 */
function GetLevel(level) {
    try {
        return JSON.parse(JSON.stringify(levels[level]))
    } catch {}
    return null
}

function GetHint(level) {
    try {
        return hints[level]
    } catch {}
    return ''
}

export { GetLevel, GetHint }